// Counted nouns shared by several surfaces, one key per plural form: the base key is the
// "other" form, `...One` the CLDR "one" form, chosen by `lib/pluralKey` (French "one" covers
// 0 and 1, English and Spanish only 1). One wording for every screen that counts a course's
// lessons — the practitioner's Learn list, the public catalogue, the course page, the
// marketplace card and Super Admin Global Learn — so one course never reads two ways.
export default {
  fr: {
    "count.lessons": "{n} leçons",
    "count.lessonsOne": "{n} leçon",
  },
  en: {
    "count.lessons": "{n} lessons",
    "count.lessonsOne": "{n} lesson",
  },
  es: {
    "count.lessons": "{n} lecciones",
    "count.lessonsOne": "{n} lección",
  },
};
